// LICENSE_CODE ZON
'use strict';

/*jslint ts:true, react:true*/
import React_origin from 'react';
export default React_origin;
export var useState = a => [a, () => {}];
export var useEffect = () => {};
export var useMemo = f => f();
export var Fragment = React_origin.Fragment;
export var useRef = a => ({
  current: a || null
});
export var useCallback = f => f;
export var createContext = d => d;
export var useContext = c => c;